import Grid from "@mui/material/Grid";
import * as React from "react";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Data

import IconButton from "@mui/material/IconButton";

import {
  List,
  ListItem,
  ListItemIcon,
  ListItemButton,
  ListItemText,
  CircularProgress,
} from "@mui/material";

import { useNavigate, useSearchParams } from "react-router-dom";

import { useEffect } from "react";
import { useState } from "react";
import MDAvatar from "components/MDAvatar";

import MDButton from "components/MDButton";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MDTypography from "components/MDTypography";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import FeedRoundedIcon from "@mui/icons-material/FeedRounded";
import RocketLaunchRoundedIcon from "@mui/icons-material/RocketLaunchRounded";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import CallIcon from "@mui/icons-material/Call";
import LogoutIcon from "@mui/icons-material/Logout";
import EditIcon from "@mui/icons-material/Edit";
import { GiWallet } from "react-icons/gi";
import nftWhite from "../../assets/images/nftLogoWhite.svg";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import { useMediaQuery } from "react-responsive";
import { getUserInfo } from "services/apiService";
import colors from "assets/theme-dark/base/colors";
import CreatePost from "layouts/createpost";
import WalletDialog from "layouts/dialogModals/WalletDialog";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "Store/slices/userAuthSlice";
import { connectWallet } from "Store/slices/walletSlice";
import { walletDisconnect } from "Store/slices/walletSlice";
import { userAppInfoReducerReset } from "Store/slices/userInfoSlice";
import { profileDataReducerReset } from "Store/slices/profileDataSlice";
import { campaignReducerReset } from "Store/slices/campaignSlice";
import { followingsDataReducerReset } from "Store/slices/followerFollowingSlice";
import { nftReducerReset } from "Store/slices/nftSlice";
import { rewardReducerReset } from "Store/slices/rewardSlice";
import { suggAndNotiReducerReset } from "Store/slices/Sugg&NotificationSlice";
import { userFeedReducerReset } from "Store/slices/userFeedSlice";

function Settings() {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const { userAppInfo, isLoadingInfo } = useSelector((state) => state.userInfo);
  const { isWeb3Enabled, address, chainId, balance, reward, isWalletLoading } =
    useSelector((state) => state.walletData);
  const [searchParams] = useSearchParams();

  const { text } = colors;
  const [profileInfo, setProfileInfo] = useState([]);
  const [firebaseTokenClient, setFirebaseTokenClient] = useState("");
  const [createPostBoolean, setCreatePostBoolean] = useState(false);
  const [walletDialogBoolean, setWalletDialogBoolean] = useState(false);

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  const handleClose = () => {
    setCreatePostBoolean(false);
  };

  const settingsList = [
    {
      name: "Edit profile",
      value: "/editProfile",
      icon: <EditIcon fontSize="medium" sx={{ color: "#fff" }} />,
    },
  ];

  const settingsList2 = [
    {
      name: "Feeds",
      value: "/",
      icon: <FeedRoundedIcon fontSize="medium" sx={{ color: "#fff" }} />,
    },
    {
      name: "Create post",
      value: true,
      icon: <AddCircleIcon fontSize="medium" sx={{ color: "#fff" }} />,
    },
    {
      name: "NFT Marketplace",
      value: "/nft-marketplace",
      icon: <img src={nftWhite} height="25" width="25px" />,
    },
    {
      name: "Campaign",
      value: "/campaigns",
      icon: <RocketLaunchIcon fontSize="medium" sx={{ color: "#fff" }} />,
    },
    {
      name: "Rewards",
      value: "/rewards",
      icon: <GiWallet style={{ color: "#fff" }} />,
    },
    {
      name: "Support",
      value: "/support",
      icon: <CallIcon fontSize="medium" sx={{ color: "#fff" }} />,
    },
    {
      name: "Logout",
      value: "/logout",
      icon: <LogoutIcon fontSize="medium" sx={{ color: "#fff" }} />,
    },
  ];

  // useEffect(() => {
  //   fetchUserDetails();
  // }, []);

  const fetchUserDetails = async () => {
    const userInfoRes = await getUserInfo(localStorage.userNameSingh);
    // console.log("profileInfoRes", userInfoRes);
    setProfileInfo(userInfoRes);
  };

  // const connectWallet = async (api) => {
  //   if (address === "") {
  //     // console.log("Empty");
  //     if (!isWeb3Enabled) {
  //       try {
  //         if (api === "ethereum") {
  //           if (window.ethereum && window.ethereum.isMetaMask) {
  //             await window.ethereum.request({ method: "eth_requestAccounts" });
  //             await enableWeb3(api);
  //           } else {
  //             await enableWeb3("walletconnect");
  //             // Redirect to the MetaMask app using the metamask:// URL scheme
  //             // const deepLink = "metamask://";
  //             // window.location.replace(deepLink);
  //             // const deepLink =
  //             //   "https://metamask.app.link/dapp/new-demo.singhcoin.io";
  //             // const deepLink = "https://metamask.app.link/dapp/app.singhcoin.io";
  //             // window.location.replace(deepLink);
  //           }
  //         } else {
  //           await enableWeb3("walletconnect");
  //         }
  //       } catch (err) {
  //         console.log("err", err);
  //       }
  //     }
  //   } else {
  //     // console.log("FULL");
  //     setWalletDialogBoolean(true);
  //   }
  // };

  const handleConnectWallet = (providerApi) => {
    if (address === "") {
      dispatch(connectWallet(providerApi));
    } else {
      setWalletDialogBoolean(true);
    }
  };

  const handleRoute = (value) => {
    // console.log("Test", value);
    if (value === "/editProfile") {
      navigate("/edit-profile");
    } else if (value === "/") {
      navigate("/");
    } else if (value === "/nft-marketplace") {
      navigate("/nft-marketplace");
    } else if (value === "/campaigns") {
      navigate("/campaigns");
    } else if (value === "/rewards") {
      navigate("/rewards");
    } else if (value === "/logout") {
      handleLogout();
      // localStorage.removeItem("userNameSingh");
      // localStorage.removeItem("jwtTokenSingh");

      // localStorage.clear();
      // window.location.href = "/";
    } else if (value === "/support") {
      window.location.href = "https://t.me/SinghApp_support";
    } else if (value === true) {
      setCreatePostBoolean(true);
    }
  };

  const handleLogout = async () => {
    dispatch(logoutUser());
    dispatch(walletDisconnect());
    dispatch(userAppInfoReducerReset());
    dispatch(profileDataReducerReset());
    dispatch(campaignReducerReset());
    dispatch(followingsDataReducerReset());
    dispatch(nftReducerReset());
    dispatch(rewardReducerReset());
    dispatch(suggAndNotiReducerReset());
    dispatch(userFeedReducerReset());
    navigate("/sign-in", { replace: true });
  };

  // const handleCopyIcon = (text) => {
  //   navigator.clipboard.writeText(text);
  //   // setCopy("Copied");
  // };

  const handleCloseWalletDialog = () => {
    setWalletDialogBoolean(false);
  };

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox sx={{ marginTop: "2rem" }}>
          <MDBox
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
              paddingLeft: "1rem",
              // marginTop: "1rem",
              marginBottom: "1rem",
            }}
          >
            <MDBox sx={{}}>
              <MDAvatar
                src={userAppInfo?.profilePic}
                sx={{ height: "70px", width: "70px" }}
                imgProps={{
                  style: { height: "100%", width: "100%" },
                }}
              />
            </MDBox>
            <MDBox>
              <MDTypography fontSize="15px" color="white">
                {userAppInfo?.fullName}
              </MDTypography>
              <MDTypography fontSize="15px" color="text">
                {userAppInfo?.email}
              </MDTypography>
            </MDBox>
          </MDBox>
          <Accordion sx={{ width: "300px", backgroundColor: "#000" }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <MDBox sx={{ display: "flex", alignItems: "center" }}>
                <ListItemIcon>
                  <AccountCircleIcon fontSize="medium" sx={{ color: "#fff" }} />
                </ListItemIcon>
                <ListItemText primary={<MDTypography>Account</MDTypography>} />
                {/* <AccountCircleRoundedIcon sx={{ color: "#fff" }} />
              <MDTypography color="text">Account</MDTypography> */}
              </MDBox>
            </AccordionSummary>
            <AccordionDetails>
              <MDBox>
                <List sx={{ paddingLeft: "10px" }}>
                  {settingsList.map((item, idx) => (
                    <ListItem key={idx} disablePadding>
                      <ListItemButton onClick={() => handleRoute(item.value)}>
                        <ListItemIcon>{item.icon}</ListItemIcon>
                        <ListItemText primary={item.name} />
                      </ListItemButton>
                    </ListItem>
                  ))}
                </List>
              </MDBox>
            </AccordionDetails>
          </Accordion>
          <MDBox>
            <List
              sx={
                {
                  // height: "500px",
                  // width: "100%",
                  // display: "flex",
                  // flexDirection: "column",
                  // flexWrap: "wrap",
                }
              }
            >
              {settingsList2.map((item, idx) => (
                <ListItem key={idx} disablePadding>
                  <ListItemButton onClick={() => handleRoute(item.value)}>
                    <ListItemIcon>{item.icon}</ListItemIcon>
                    <ListItemText
                      primary={<MDTypography>{item.name}</MDTypography>}
                    />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </MDBox>

          {isTabletOrMobile && (
            <MDBox sx={{ padding: "1rem", marginBottom: "1rem" }}>
              <MDBox>
                <MDTypography color="singh">Wallet address</MDTypography>
                <MDButton
                  fullWidth
                  sx={{ fontSize: "11px" }}
                  variant="outlined"
                  color="singh"
                  endIcon={
                    address !== "" ? (
                      <IconButton
                        sx={{ margin: 0, padding: 0, color: "inherit" }}
                      >
                        <ContentCopyIcon />
                      </IconButton>
                    ) : null
                  }
                  onClick={() => handleConnectWallet("ethereum")}
                  // onClick={() => handleCopyIcon(address)}
                >
                  <MDTypography fontSize="0.7rem">
                    {isWalletLoading ? (
                      <CircularProgress size={15} color="inherit" />
                    ) : isWeb3Enabled ? (
                      // Number(balance).toFixed(2)
                      address
                    ) : (
                      "Connect Wallet"
                    )}
                  </MDTypography>
                </MDButton>
              </MDBox>
            </MDBox>
          )}
        </MDBox>
        {/* <Footer /> */}
      </DashboardLayout>

      {walletDialogBoolean && (
        <WalletDialog
          openStatus={walletDialogBoolean}
          onClose={() => handleCloseWalletDialog()}
          // postId={postId}
          // type={type}
        />
      )}

      {createPostBoolean && (
        <CreatePost
          openStatus={createPostBoolean}
          onClose={() => handleClose()}
        />
      )}
    </>
  );
}

export default Settings;
